import ReactApexChart from "react-apexcharts";

function getRandomInt() {
  return Math.floor(Math.random() * 101);
}

const CsosFinanceColumns = ({ comparisonData, activeColumnFilter }) => {
  const years = comparisonData.year;

  const rawComparisonData = {
    ...comparisonData,
  };
  delete rawComparisonData.year;
  const columnFilters = Object.keys(rawComparisonData);
  const csos = rawComparisonData[columnFilters[0]].map((cso) => {
    return cso.cso_name;
  });

  const mappedComparisonData = Object.keys(rawComparisonData).reduce(
    (acc, axisKey) => {
      acc[axisKey] = rawComparisonData[axisKey].reduce((accChild, currCso) => {
        accChild[currCso.cso_name] = currCso.data;
        // accChild[currCso.cso_name] = [
        //   getRandomInt(),
        //   getRandomInt(),
        //   getRandomInt(),
        // ];
        return accChild;
      }, {});
      return acc;
    },
    {}
  );

  const series = years.map((year, idx) => {
    return {
      name: year,
      data: csos.map((companyKey) => {
        return mappedComparisonData[columnFilters[activeColumnFilter]][
          companyKey
        ][idx];
      }),
    };
  });

  const options = {
    labels: csos.map((item) => {
      if (item.length > 10) {
        return item.slice(0, 10) + "..";
      }
      return item;
    }),
    fill: {
      opacity: 0.6,
    },
    chart: {
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      labels: {
        formatter: function (num) {
          if (num === Infinity) return "";
          // check if number is greater than 0
          if (num < 1) {
            // round to 2 decimal places
            num = Math.round(num * 100) / 100;
            return num;
          }
          // Convert the number to a string and remove any decimal places
          const numString = Math.floor(num).toString();
          // Split the number string into groups of three from the right side
          const groups = [];
          let remainder = numString.length % 3;
          if (remainder !== 0) {
            groups.push(numString.slice(0, remainder));
          }
          for (let i = remainder; i < numString.length; i += 3) {
            groups.push(numString.slice(i, i + 3));
          }
          // Join the groups with commas and return the result
          return groups.join(",");
        },
      },
    },
  };

  return <ReactApexChart type="bar" series={series} options={options} />;
};

export default CsosFinanceColumns;
